<script setup lang="ts">
import { useNavigationStore } from '../../stores/navigationStore'
import type { NavigationStep } from '../../types'

const navStore = useNavigationStore()

function goTo(step: NavigationStep, index: number) {
  if (index === navStore.navigationPath.length - 1) return
  // Navigate back to this level
  const targetPath = navStore.navigationPath.slice(0, index + 1)
  navStore.navigationPath = targetPath
  navStore.currentLevel = step.level

  // Clear deeper state
  if (step.level === 'vehicle') {
    navStore.mainGroupId = null
    navStore.mainGroupSvg = null
    navStore.subGroupId = null
    navStore.subGroupSvg = null
    navStore.itemId = null
  } else if (step.level === 'mainGroup') {
    navStore.subGroupId = null
    navStore.subGroupSvg = null
    navStore.itemId = null
  } else if (step.level === 'subGroup') {
    navStore.itemId = null
  }
}
</script>

<template>
  <nav v-if="navStore.navigationPath.length > 0" class="breadcrumb-nav" aria-label="Navigasjon">
    <ol class="breadcrumb-nav__list">
      <li
        v-for="(step, i) in navStore.navigationPath"
        :key="`${step.level}-${step.id}`"
        class="breadcrumb-nav__item"
        :class="{ 'breadcrumb-nav__item--active': i === navStore.navigationPath.length - 1 }"
      >
        <button
          v-if="i < navStore.navigationPath.length - 1"
          class="breadcrumb-nav__link"
          @click="goTo(step, i)"
        >
          {{ step.name }}
        </button>
        <span v-else class="breadcrumb-nav__current">{{ step.name }}</span>
        <span v-if="i < navStore.navigationPath.length - 1" class="breadcrumb-nav__sep">&rsaquo;</span>
      </li>
    </ol>
  </nav>
</template>

<style scoped lang="scss">
.breadcrumb-nav {
  margin-bottom: 1rem;

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.25rem;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.9rem;
  }

  &__link {
    background: none;
    border: none;
    color: #002868;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    text-decoration: underline;
    text-transform: capitalize;

    &:hover {
      background: #f0f4f8;
    }
  }

  &__current {
    font-weight: 600;
    color: #333;
    text-transform: capitalize;
  }

  &__sep {
    color: #999;
    font-size: 1.1rem;
  }
}
</style>
